import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { fetchAgencyDetails, getAgencyInfo, getAgentVoice, getDecodeData, getIconByVoiceId, getVoiceList, loadWebWidgetData, parseJSON } from "../../Common/Appcommon";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import cx from "classnames";
import "./index.css"
import { useWebCallContext } from '../Agents/context';
import requestApiService from "../../services/requestApi.service";
import { useAppContext } from "../../Context/AppContext";
const WebsiteWidget = (props) => {
    const { data, token } = props;
    const formname = "table_250";
    const { startCall, stopCall, isCallStarted, setIsCallStarted,transcript, setTranscript,showTranscript,setShowTranscript, error,setError} = useWebCallContext();
    const { voiceAgList } = useAppContext();
    //const { token } = useParams();
    const [isLiveMode, setIsLiveMode] = useState(false);
    const [rowData, setRowData] = useState({});
    const [showWidget, setShowWidget] = useState(false);
    const [agencyLogo, setAgencyLogo] = useState("");
    const [mediaUrl, setMediaUrl] = useState("");
    const [apiDetails, setApiDetails] = useState({});
    const [isCallInitiated, setCallInitiated] = useState(false);
    const [agentIcon,setAgentIcon] = useState(null);
    const transcriptRef = useRef(null);
    useEffect(()=>{
        //DisconnectCall It Cut but a agent are error
        if(error){
            onDisconnectCall();
        }
    },[error])
    useEffect(() => {
        const fetchData = async () => {
            let voiceid;
            let option;
            if (token) {
                setIsLiveMode(true);
                const widgetResult = await loadWebWidgetData(token);
                if(widgetResult.length <= 0){
                    return;
                }
                const rowdataDB = widgetResult['widget'];
                let api = widgetResult['apidetails'];
                let appid = widgetResult['SUBACCOUNTID'];
                let agentAccountId = widgetResult['AccountID'];
                api['providerDetails'] = getDecodeData(api['providerDetails'],appid,agentAccountId)
                let provider = api['provider'];
                const agencyDetails = await fetchAgencyDetails(agentAccountId);
                setAgencyLogo(agencyDetails[0] ?? "");
                let brand_logo = rowdataDB["brand_logo"] ? parseJSON(rowdataDB["brand_logo"]) : {};
                setMediaUrl(brand_logo.mediaUrl);
                if (rowdataDB) {
                    setRowData(rowdataDB);
                }
                if (api) {
                    setApiDetails(api);
                }
                const agentDetails = await getAgentVoice(appid);
                const voiceList = await getVoiceList(provider);
                option = voiceList[0];
                let data = agentDetails.data;
                let agentId = rowdataDB['agent_id'];
                voiceid = data.find(item => item[0] === agentId);
                voiceid = voiceid?.[1] ?? "";

            } else {
                let agencyLogoInfo = getAgencyInfo("Logo");
                let agencyLogo = "";
                if (agencyLogoInfo !== "" && agencyLogoInfo !== undefined && agencyLogoInfo !== null) {
                    if (agencyLogoInfo.indexOf(",") > 0) {
                        let agentLArr = agencyLogoInfo.split(",");
                        agencyLogo = agentLArr[1];
                    }
                }
                let brand_logo = data["brand_logo"] ? parseJSON(data["brand_logo"]) : {};
                setMediaUrl(brand_logo.mediaUrl);
                setAgencyLogo(agencyLogo);
                setShowWidget(true);
                setIsLiveMode(false);
                setRowData(data);
                voiceid = data?.agent?.voiceid ?? "";
                option = voiceAgList[0]
            }
            let icon = getIconByVoiceId(voiceid,option);
            setAgentIcon(icon);
        };
        fetchData();
    }, [data, token]);

    const onCallWidgetClick = () => {
        if (isLiveMode && !isCallInitiated) {
            setShowWidget(!showWidget);
            if (window && window.parent) {
                let fn = "minimizeWindow";
                if (!showWidget) {
                    fn = "restoreWindow";
                }
                window.parent.postMessage({ src: 'cratio.whatsapp.widget', fn: fn, args: [] }, '*');
            }
        }
        if (isCallInitiated) {
            onDisconnectCall();
        }
    }

    const onDisconnectCall = () => {
        setCallInitiated(false);
        setIsCallStarted(false);
        setTranscript([]);
        setShowTranscript(false);
        setError(false)
        stopCall();
    }

    const onInitiateCallAction = async (e) => {
        if(isCallInitiated && !isCallStarted) return;
        if (isCallStarted) {
            onDisconnectCall();
        } else {
            let agentId = rowData['agent_id'];
            let reqobj = {
                ENTITY: "GET_WIDGET",
                OPERATION: "GET_AGENT",
                agent: agentId,
                formname: formname,
                token: token
            };
            let response = await requestApiService.processServerRequest(reqobj);
            if (response.issuccess) {
                let res = response.data;
                if (res['agent'] !== undefined) {
                    setCallInitiated(true);
                    setError(false);
                    startCall(res['agent'], apiDetails);
                }
            }
        }

    }

    useEffect(() => {
        if (transcriptRef.current) {
            transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight;
        }
    }, [transcript]);
    const onChangeTranscript = () =>{
        setShowTranscript(!showTranscript);
    }
    return (
        rowData && Object.keys(rowData).length > 0 &&
        <div className="container my-4 d-flex justify-content-center m-3 web-call-widget">
            <div className={cx("text-center", { "call-widget-live": isLiveMode }, { "align-widget-right": rowData["position"] === "right" }, { "align-widget-left": rowData["position"] === "left" })} style={{ width: showTranscript ? '600px' : '300px' ,   right: showTranscript && rowData["position"] === "right" ? "-158px" : undefined}}>
                {
                    !isLiveMode &&
                    <h6 className="mb-3">Chat Widget preview</h6>
                }
                {
                    showWidget &&
                    <div className="border rounded shadow-sm bg-light widget-max-wid" style={{ width: showTranscript ? '390px' : '' }}>
                        <div className="d-flex align-items-center p-3 bg-light border rounded">
                            <img
                                src={mediaUrl}
                                className="rounded-circle border me-3"
                                style={{ width: "36px", height: "36px", objectFit: "cover" }}
                            />
                            <div className="text-start w-75">
                                <div className="fw-bold  w-75 txt-ovrflw">{rowData["brand_name"]}</div>
                                <div className="text-muted small w-100 txt-ovrflw">{rowData["subtitle"]}</div>
                            </div>
                        </div>

                        {!showTranscript && (
                            <div className="p-3 text-center">
                                <span className="fs-3">
                                    {
                                        agentIcon !== null ? 
                                        <img
                                            className="widget-voice-img-crop"
                                            src={agentIcon}
                                            alt=""
                                        />:<i className="fi fi-ss-user-headset"></i>
                                    }
                                </span>
                                {
                                    rowData["status"] === "Active" || !isLiveMode ? (
                                        <div className={"text-success fw-semibold mb-1"}>● Available</div>
                                    ) : (
                                        <div className={"text-danger fw-semibold mb-1"}>● Not Available</div>
                                    )
                                }
                                <p className="mb-0 text-muted small">{rowData["welcome_text"]}</p>
                            </div>
                        )}
                        {isLiveMode && isCallStarted  &&  showTranscript && 
                            (
                                <>
                                    <div className="transcript-containter mb-3" ref={transcriptRef}>
                                        {transcript && transcript.length > 0 ? (
                                                <div className="">
                                                    {transcript.map((field, index) => {
                                                        return (
                                                            <div key={index}>
                                                                {field.role === "agent" && (
                                                                    <div className='popover-transcript-contant-agent  w-100 me-1'>
                                                                        <div className='transcript-dur transcript-font'>
                                                                            <span>Agent</span>
                                                                        </div>
                                                                        <div className='transcript-bot-msg-width transcript-font'>
                                                                            <div>{field.content}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {field.role === "user" && (
                                                                    <div className='popover-transcript-contant-user w-100 ms-1'>
                                                                        <div className='transcript-user-header transcript-font'>
                                                                            <span>User</span>
                                                                        </div>
                                                                        <div className='transcript-bot-msg-width transcript-font'>
                                                                            <div>{field.content}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <> </>
                                            )}
                                    </div>
                                </>   
                            )
                        }

                        {
                            (rowData["status"] === "Active" || !isLiveMode) &&
                            <div className="p-3 border-top d-flex">
                                <button onClick={(e) => (onInitiateCallAction(e))} className="btn w-100 d-flex justify-content-center align-items-center gap-2 me-1" style={{ backgroundColor: rowData["button_color"], color: (rowData["text_color"] === "light" ? "#ffffff" : "#000000") }}>
                                    <i class="fi fi-rr-phone-call"></i> {isCallInitiated && !isCallStarted ? "Ringing" : isCallStarted ? "Disconnect" : rowData["call_btn_text"]}
                                </button>
                                {
                                    isCallStarted && (
                                        <>
                                            <button onClick={(e) => (onChangeTranscript())} className="btn w-100 d-flex justify-content-center align-items-center gap-2 me-1" style={{ backgroundColor: rowData["button_color"], color: (rowData["text_color"] === "light" ? "#ffffff" : "#000000") }}>
                                                <i class={`${showTranscript ? "fi fi-rr-symbol" : 'fi fi-sr-align-slash'}`}></i>
                                            </button>
                                        </>
                                    )
                                }
                            </div>
                        }

                        {
                            rowData["branding"] &&
                            <div className="text-center pb-2">
                                <small className="text-muted">Powered by</small><br />
                                <img src={agencyLogo} alt="Logo" style={{ height: "20px" }} />
                            </div>
                        }
                    </div>
                }

                {
                    isLiveMode ? (
                        <div className={"position-fixed call-btn-live fs-5 " + (rowData["position"] === "right" ? "align-btn-right" : "align-btn-left")}
                            style={{
                                backgroundColor: rowData["button_color"],
                                color: rowData["text_color"] === "light" ? "#ffffff" : "#000000",
                            }}
                            onClick={() => onCallWidgetClick()}
                        >
                            {
                                showWidget ? (
                                    <i class="fi fi-rr-cross pt-1"></i>
                                ) : (
                                    <i class="fi fi-rr-phone-call pt-1"></i>
                                )
                            }
                        </div>
                    ) : (
                        <div className="d-flex w-100 call-btn-prev">
                            <div className={"mt-1 " + (rowData["position"] === "right" ? "ms-auto" : "me-auto")}
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    backgroundColor: rowData["button_color"],
                                    color: rowData["text_color"] === "light" ? "#ffffff" : "#000000",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                }}
                            >
                                <i class="fi fi-rr-phone-call"></i>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteWidget);